export default __webpack_public_path__ + "static/media/stone-guardian--side--240.fd096b95.jpg";